import { render, staticRenderFns } from "./DeleteSpaces.vue?vue&type=template&id=02f0cd12&"
import script from "./DeleteSpaces.vue?vue&type=script&lang=js&"
export * from "./DeleteSpaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports